module.exports = function() {
  return new Worker(__webpack_public_path__ + "1870f935f4a73510e318.worker.js");
};